import axios from '@/utils/api' // eslint-disable-line
import { KEYS, setItem } from '@/store/local/localStorage'

const actions = {
  async cadastrarUsuario ({ commit }, { usuario, isExterno }) {
    const data = await axios({
      method: 'post',
      data: usuario,
      url: isExterno ? 'usuarios/publico/create' : 'usuarios/create'
    })
    return data
  },

  async findEmailByCpfCnpj ({ commit }, cpfCnpj) {
    const data = await axios({
      method: 'get',
      url: `usuarios/publico/findEmailByCpfCnpj`,
      params: {
        cpfCnpj
      }
    })
    return data
  },

  async requestRedefinirSenha ({ commit }, info) {
    const login = info.cpfCnpj
    const email = info.email
    const data = await axios({
      method: 'get',
      url: `usuarios/publico/requestRedefinirSenha`,
      params: {
        login,
        email
      }
    })
    return data
  },

  async redefinirSenha ({ commit }, dto) {
    const data = await axios({
      method: 'post',
      data: dto,
      url: `usuarios/publico/redefinirSenha`
    })
    return data
  },

  async findUsuarioByCpfCnpj ({ commit }, cpfCnpj) {
    const data = await axios({
      method: 'get',
      url: 'usuarios/publico/findByCpfCnpj',
      params: {
        cpfCnpj
      }
    })

    return data
  },

  async getInfoTokenAssinatura ({ commit }, id) {
    const data = await axios({
      method: 'GET',
      url: `usuarios/${id}/getInfo/token/assinatura`
    })

    return data
  },

  async usuarioHasProcesso ({ commit }, cpfCnpj) {
    const data = await axios({
      method: 'get',
      url: 'usuarios/hasProcesso',
      params: {
        cpfCnpj
      }
    })
    return data
  },

  async bloquearUsuario ({ commit }, blockData) {
    const data = await axios({
      method: 'post',
      data: blockData,
      url: `usuarios/bloquear`
    })
    return data
  },

  async findUsuariosByFilter ({ commit }, filtro) {
    const data = await axios({
      method: 'post',
      data: filtro,
      url: `usuarios/findByFilter`
    })
    return data
  },

  async alterarPerfis ({ commit }, perfilData) {
    await axios({
      method: 'post',
      data: perfilData,
      url: `usuarios/alterarPerfis`,
      error: true
    })
  },

  async findAllPerfis ({ commit }, pessoa) {
    const data = await axios({
      method: 'get',
      url: `publico/perfil`,
      params: {
        idPessoa: pessoa ? pessoa.id : null
      }
    })
    return data
  },

  async findPerfisBySetor ({ commit }, setores) {
    const data = await axios({
      method: 'post',
      url: `publico/perfil/perfisBySetor`,
      data: [ ...setores ]
    })
    return data
  },

  async findHistorico ({ commit }, id) {
    const data = await axios({
      method: 'get',
      url: 'usuarios/historicoAlteracao/' + id
    })
    return data
  },

  async downloadDocumentoAlteracao ({ commit }, id) {
    const data = await axios({
      method: 'post',
      url: 'usuarios/downloadDocumentoAlteracao',
      data: { id },
      responseType: 'blob'
    })
    return data
  },

  async findAll ({ commit }) {
    const data = await axios({
      method: 'get',
      url: 'usuarios/publico/findAll',
      loader: false
    })
    return data
  },

  async findModulosUsuario ({ commit }, idUsuario) {
    const data = await axios({
      method: 'get',
      url: `usuarios/${idUsuario}/modulos`
    })
    return data
  },

  async findPerfisUsuario ({ commit }, { idUsuario, idModulo }) {
    const data = await axios({
      method: 'get',
      url: `usuarios/${idUsuario}/modulo/${idModulo}/perfis`
    })
    return data
  },

  async getMessageNotificacao ({ commit }, idUsuario) {
    const data = await axios({
      method: 'get',
      url: `usuarios/${idUsuario}/message`
    })

    return data
  },

  async findVistoriadorExternoByCpfCnpj ({ commit }, cpfCnpj) {
    const data = await axios({
      method: 'get',
      url: 'usuarios/vistoriador/externo/findByCpfCnpj',
      params: {
        cpfCnpj
      }
    })

    return data
  },

  async getTermoDeUso ({ commit }) {
    const data = await axios({
      method: 'get',
      url: `usuarios/publico/getTermoUso`
    })

    return data
  },

  async getPoliticaDePrivacidade ({ commit }) {
    const data = await axios({
      method: 'get',
      url: `usuarios/publico/getPoliticaPrivacidade`
    })

    return data
  },

  async setTermosAceitos ({ commit, dispatch }) {
    const data = await axios({
      method: 'get',
      url: `usuarios/setTermosAceitos`
    })

    setItem(KEYS.LOGIN.jwt, `${data.tokenType} ${data.accessToken}`)
    setItem(KEYS.LOGIN.token, `${data.accessToken}`)

    const usuario = await dispatch('getUsuario')
    commit('SET_USUARIO', usuario)

    return data
  },

  findResponsaveisBySetorLogado ({ commit }) {
    return axios({
      method: 'get',
      url: `usuarios/responsaveis/setorLogado`
    })
  },

  async downloadCartilha ({ commit }) {
    const response = await axios({
      method: 'post',
      url: 'cartilha/download',
      responseType: 'blob'
    })
    const blob = response.data || response
    const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', 'Cartilha_de_Qualificacao_ao_Plano_ABC_PA.pdf')
    document.body.appendChild(link)
    link.click()
    link.remove()
    window.URL.revokeObjectURL(url)
    return blob
  }

}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/portal/seguranca/usuario.js